import { UnscheduledSectionServant } from '../../unscheduled_sections/servants/unscheduled_section_servant';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { ScheduledSectionStatusServant } from '../../course_scheduler/servants/scheduled_section_status_servant';

type t_seats_state = 'unlimited' | 'available' | 'full' | 'waitlist';

class SeatsInfoText {
  private section: ISection;
  private seatsText: string;
  private canAddToWaitlist: boolean = false;
  private shouldShowSeatsInfo = false;
  constructor(
    private ngUnscheduledSectionServant: UnscheduledSectionServant,
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant
  ) {}
  initialize() {
    this.seatsText = this.computeSeatsText(this.computeSeatsState());
    this.shouldShowSeatsInfo = !this.isSectionRegisteredInprogressCompleted();
    this.canAddToWaitlist = this.ngUnscheduledSectionServant.canAddToWaitlist(this.section);
  }

  computeSeatsState(): t_seats_state {
    const isUnlimitedSeating = this.section.is_unlimited_seating;

    if (isUnlimitedSeating) {
      return 'unlimited';
    }

    const isSectionWaitlisted = this.ngScheduledSectionStatusServant.isStatusWaitlisted(this.section);
    const isSectionFull = this.ngUnscheduledSectionServant.isSectionFull(this.section);
    const doesSectionHaveSeats = this.section.seats_offered > 0;
    if (isSectionWaitlisted && isSectionFull && doesSectionHaveSeats) {
      return 'available';
    }

    const isSectionBlocked = !this.canAddToWaitlist;
    if (isSectionFull && isSectionBlocked) {
      return 'full';
    }

    const canSectionBeWaitlisted = this.canAddToWaitlist;
    if (canSectionBeWaitlisted) {
      return 'waitlist';
    }

    return 'available';
  }

  computeSeatsText(state: t_seats_state) {
    switch (state) {
      case 'unlimited':
        return 'Unlimited Seating';
      case 'full':
        return 'FULL';
      case 'waitlist':
        return 'Waitlist Available';
      case 'available':
      default:
        return this.getAvailableSeatsText();
    }
  }

  getAvailableSeatsText() {
    const pluralText = this.section.seats_offered > 1 ? 's' : '';
    const availableSeats = !_4.isUndefined(this.section._availability) ? this.section._availability.avail_seats : '';

    return `${availableSeats} seat${pluralText} available`;
  }

  $onInit() {
    this.initialize();
  }
  $onChanges(changes: { section: any }) {
    this.initialize();
  }

  isSectionRegisteredInprogressCompleted() {
    return (
      this.ngScheduledSectionStatusServant.isRegisteredOrInprogress(this.section) ||
      this.ngScheduledSectionStatusServant.isCompleted(this.section) ||
      this.ngScheduledSectionStatusServant.isStatusWithdrawn(this.section)
    );
  }
}

angular.module('capability-ng-scheduler').component('seatsInfoText', {
  bindings: {
    section: '<',
    availability: '<',
    isScheduled: '<'
  },
  templateUrl: 'capability-ng-scheduler/src/views/components/seats_info_text/seats_info_text.html',
  controller: SeatsInfoText
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/seats_info_text/seats_info_text.ts